// Return percentage with one decimal place
export const getPercent = (value, total) => {
    if (total === 0) return '0.0';  // Avoid division by zero
    return ((value / total) * 100).toFixed(1);
}
